export default "__VITE_ASSET__6503dc88__"